import { j as r } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const t = e((o, s) => /* @__PURE__ */ r.jsx(
  l,
  {
    ref: s,
    ...o,
    image: (a) => /* @__PURE__ */ r.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: /* @__PURE__ */ r.jsx(
          "path",
          {
            fill: "currentColor",
            d: "m11.207.793 3.5 3.5a1 1 0 0 1 0 1.414l-3.5 3.5-1.414-1.414 1.785-1.786H6v-2h5.593l-1.8-1.8zM4.793 6.793l-3.5 3.5a1 1 0 0 0 0 1.414l3.5 3.5 1.414-1.414-1.785-1.785H10v-2H4.407l1.8-1.8z"
          }
        )
      }
    )
  }
));
t.displayName = "TransferIcon";
export {
  t as TransferIcon,
  t as default
};
//# sourceMappingURL=index.js.map
